// extracted by mini-css-extract-plugin
module.exports = {"image":"ImageElementButton_image__3u9Qr","confirmedOverlay":"ImageElementButton_confirmedOverlay__3G6fc"};